import React, { useEffect } from "react";
import { TextField, MenuItem, ListItemText, Autocomplete } from "@mui/material";
import { Box } from "@mui/system";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import Grid from "@mui/material/Grid";
import { useStateList } from "./HandleInvoiceStateProvider";

const transportModes = [
  { option: "Railways", value: "Railways" },
  { option: "Air", value: "Air" },
  { option: "Road", value: "Road" },
  { option: "Ship", value: "Ship" },
];
function DispatchDetails({ Type }) {
  const {
    setInitialState,
    data,
    setData,
    viewMode,
    deispatchAccordion,
    setDispatchAccordion,
    invoiceEntry,
    registrationType,
  } = useStateList();

  const handleTransportModeChange = (e) => {
    const value = e.target.value;

    setData((prev) => ({
      ...prev,
      transportMode: value,
    }));
  };
  const handleVehicleNumberChange = (e) => {
    const value = e.target.value;

    setData((prev) => ({
      ...prev,
      vehicleNumber: value,
    }));
  };
  const handleDateOfDispatchChange = (e) => {
    const value = e.target.value;

    setData((prev) => ({
      ...prev,
      dateOfDispatch: value,
    }));
  };
  const handleEwayBillNoChange = (e) => {
    const value = e.target.value;

    setData((prev) => ({
      ...prev,
      ewayBillNo: value,
    }));
  };

  const handleEwayBillNoKeyDown = (e) => {
    if (e.key === "Tab" || e.shiftKey) {
      e.preventDefault();
      e.stopPropagation();
      const element = document.getElementById("dateOfDispatch");
      element?.focus();
      return;
    }
    if (e.key === "Enter" || (e.key === "Tab" && !e.shiftKey)) {
      const element = document.getElementById("remarks");
      alert(element);
      element?.focus();
    }
  };
  function getDispatchDetails(invoiceEntry) {
    if (invoiceEntry?.length !== 0) {
      if (invoiceEntry?.relatedinvoicedispatch?.length > 0) {
        let dispatch = new Date(
          Number(invoiceEntry?.relatedinvoicedispatch[0].dispatchdate) * 1000
        );
        let dispatchyy = dispatch.getFullYear();
        let dispatchmm = dispatch.getMonth() + 1;
        let dispatchdd = dispatch.getDate();

        if (dispatchdd < 10) dispatchdd = "0" + dispatchdd;
        if (dispatchmm < 10) dispatchmm = "0" + dispatchmm;

        const dispatchDate = dispatchyy + "-" + dispatchmm + "-" + dispatchdd;
        setData((prev) => ({
          ...prev,
          transportMode: `${invoiceEntry?.relatedinvoicedispatch[0].transportationcd}`,
          vehicleNumber: invoiceEntry?.relatedinvoicedispatch[0].vehiclenumber,
          dateOfDispatch:
            invoiceEntry?.relatedinvoicedispatch[0].dispatchdate === 0
              ? ""
              : dispatchDate,
          ewayBillNo: `${invoiceEntry?.relatedinvoicedispatch[0].ewaybillnumber}`,
        }));
        if (setInitialState) {
          setInitialState((prev) => ({
            ...prev,
            transportMode: `${invoiceEntry?.relatedinvoicedispatch[0].transportationcd}`,
            vehicleNumber:
              invoiceEntry?.relatedinvoicedispatch[0].vehiclenumber,
            dateOfDispatch:
              invoiceEntry?.relatedinvoicedispatch[0].dispatchdate == 0
                ? ""
                : dispatchDate,
            ewayBillNo: `${invoiceEntry?.relatedinvoicedispatch[0].ewaybillnumber}`,
          }));
        }
      }
    }
  }
  function getDispatchDetailsOfCrDr(invoiceEntry) {
    if (invoiceEntry.length !== 0) {
      if (invoiceEntry?.relatedcrdrnotedispatch?.length > 0) {
        let dispatch = new Date(
          Number(invoiceEntry?.relatedcrdrnotedispatch[0].dispatchdate) * 1000
        );
        let dispatchyy = dispatch.getFullYear();
        let dispatchmm = dispatch.getMonth() + 1;
        let dispatchdd = dispatch.getDate();

        if (dispatchdd < 10) dispatchdd = "0" + dispatchdd;
        if (dispatchmm < 10) dispatchmm = "0" + dispatchmm;

        const dispatchDate = dispatchyy + "-" + dispatchmm + "-" + dispatchdd;
        setData((prev) => ({
          ...prev,
          transportMode: `${invoiceEntry?.relatedcrdrnotedispatch[0].transportationcd}`,
          vehicleNumber: invoiceEntry?.relatedcrdrnotedispatch[0].vehiclenumber,
          dateOfDispatch:
            invoiceEntry?.relatedcrdrnotedispatch[0].dispatchdate === 0
              ? ""
              : dispatchDate,
          ewayBillNo: `${invoiceEntry?.relatedcrdrnotedispatch[0].ewaybillnumber}`,
        }));
        if (setInitialState) {
          setInitialState((prev) => ({
            ...prev,
            transportMode: `${invoiceEntry?.relatedcrdrnotedispatch[0].transportationcd}`,
            vehicleNumber:
              invoiceEntry?.relatedcrdrnotedispatch[0].vehiclenumber,
            dateOfDispatch:
              invoiceEntry?.relatedcrdrnotedispatch[0].dispatchdate == 0
                ? ""
                : dispatchDate,
            ewayBillNo: `${invoiceEntry?.relatedcrdrnotedispatch[0].ewaybillnumber}`,
          }));
        }
      }
    }
  }
  const focusRoundOffFromTransportMode = () => {
    const roundOffInput = document.getElementById("roundOff");
    if (roundOffInput) {
      roundOffInput.focus();
    }
  };
  
  useEffect(() => {
    if (Type === "Sales") {
      getDispatchDetails(invoiceEntry);
    }
    if (Type === "CreditNote" || Type === "DebitNote") {
      getDispatchDetailsOfCrDr(invoiceEntry);
    }
  }, [invoiceEntry]);
  return (
    <>
      <Accordion
        onChange={(e, expanded) => {
          if (expanded) {
            setDispatchAccordion(true);
          } else {
            setDispatchAccordion(false);
          }
        }}
        sx={{
          ".MuiAccordionSummary-root": {
            minHeight: "100% !important",
            paddingLeft:"0px "
          },
        }}
        defaultExpanded
      >
        <AccordionSummary
          aria-controls="panel1-content"
          id="panel1-header"
          sx={{
            fontWeight: 700,
            color: "primary.main",
            ".css-o4b71y-MuiAccordionSummary-content.Mui-expanded": {
              // m: 1,
            },
            "& .MuiAccordionSummary-content": {
               marginTop: Type === "DebitNote" ?  "24px" : "0px",
              
            },
          }}
        >
          Dispatch Details
          {deispatchAccordion === false ? (
            <ExpandMoreIcon sx={{ color: "primary.main" }} />
          ) : (
            <ExpandLessIcon sx={{ color: "primary.main" }} />
          )}
        </AccordionSummary>
        <AccordionDetails>
          <Box
            className={viewMode == true ? "disable-interactions" : ""}
            sx={{
              display: "flex",
              flexWrap: { xs: "wrap", md: "nowrap" },
              flexDirection: { xs: "column", md: "row" },
            }}
          >
            <Grid container spacing={2}>
              <Grid item lg={3} xs={12} md={6}>
                {/* <TextField
                  select
                  id="transportMode"
                  name="transportMode"
                  label="Transportation Mode"
                  variant="outlined"
                  size="small"
                  disabled={data.partyName.value === "" ? true : false}
                  fullWidth
                  value={data.transportMode}
                  onChange={handleTransportModeChange}
                  sx={{
                    ".MuiOutlinedInput-root": {
                      height: "35px",
                    },
                  }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                >
                  {[
                    { option: "Railways", value: "Railways" },
                    { option: "Air", value: "Air" },
                    { option: "Road", value: "Road" },
                    { option: "Ship", value: "Ship" },
                  ].map((item, ind) => {
                    return (
                      <MenuItem key={item.value} value={`${item.value}`}>
                        <ListItemText
                          sx={{ margin: "0px" }}
                          primary={item.option}
                        />
                      </MenuItem>
                    );
                  })}
                </TextField> */}
                <Autocomplete
                  id="transportMode"
                  size="small"
                  fullWidth
                  options={transportModes}
                  disableClearable
                  value={
                    transportModes.find(
                      (item) => item.value === String(data.transportMode)
                    ) || null
                  }
                  onChange={(event, newValue) => {
                    handleTransportModeChange({
                      target: {
                        name: "transportMode",
                        value: newValue ? newValue.value : "",
                      },
                    });
                  }}
                  disabled={data.partyName.value === ""}
                  getOptionLabel={(option) => option.option}
                  isOptionEqualToValue={(option, value) =>
                    option.value === value.value
                  }
                  onKeyDown={(e) => {
                    if (e.shiftKey && e.key === "Tab") {
                      e.preventDefault();
                      focusRoundOffFromTransportMode();
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Transportation Mode"
                      variant="outlined"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      sx={{
                        ".MuiOutlinedInput-root": {
                          height: "35px",
                        },
                      }}
                    />
                  )}
                  renderOption={(props, option) => (
                    <li {...props} key={option.value}>
                      <ListItemText
                        sx={{ margin: "0px" }}
                        primary={option.option}
                      />
                    </li>
                  )}
                />
              </Grid>
              <Grid item lg={3} xs={12} md={6}>
                <TextField
                  id="vehicleNumber"
                  name="vehicleNumber"
                  label="Vehicle Number"
                  variant="outlined"
                  size="small"
                  disabled={data.partyName.value === "" ? true : false}
                  fullWidth
                  value={data.vehicleNumber}
                  onChange={handleVehicleNumberChange}
                />
              </Grid>
              <Grid item lg={3} xs={12} md={6}>
                <TextField
                  error={
                    data.errorStatus.dateOfDispatch === true ? true : false
                  }
                  id="dateOfDispatch"
                  name="dateOfDispatch"
                  label="Date of Dispatch"
                  variant="outlined"
                  disabled={data.partyName.value === "" ? true : false}
                  size="small"
                  type="date"
                  value={data.dateOfDispatch}
                  onChange={handleDateOfDispatchChange}
                  // onKeyDown={(event) => {
                  //   if (event.key !== "Tab") {
                  //     event.preventDefault();
                  //   }
                  // }}
                  onInput={handleDateOfDispatchChange}
                  fullWidth
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
              {registrationType !== 1 && (
                <>
                  <Grid item lg={3} xs={12} md={6}>
                    <TextField
                      id="ewayBillNo"
                      name="ewayBillNo"
                      label="EWay Bill Number"
                      variant="outlined"
                      size="small"
                      fullWidth
                      disabled={data.partyName.value === "" ? true : false}
                      value={data.ewayBillNo}
                      onChange={handleEwayBillNoChange}
                      // onKeyDown={handleEwayBillNoKeyDown}
                    />
                  </Grid>
                </>
              )}
            </Grid>
          </Box>
        </AccordionDetails>
      </Accordion>
    </>
  );
}

export default DispatchDetails;
